<template>
    <app-content class="h-panel">
        <div class="h-panel-bar">
            <span class="h-panel-title">资金报表</span>
        </div>
        <div class="margin-top margin-left filter-bar">
            <span class="label">期间：</span>
            <DatePicker v-model="p1" type="month" format="yyyy-MM"></DatePicker>
            <span class="label">至</span>
            <DatePicker v-model="p2" type="month" format="yyyy-MM"></DatePicker>
            <Button color="primary" size="s" @click="loadList">查询</Button>
            <span class="flex-spacer"></span>
            <Button size="s" @click="exportCsv">导出</Button>
            <Button size="s" @click="printPage">打印</Button>
        </div>
        <div class="h-panel-body">
            <Tabs :datas="tabDatas" v-model="groupBy" @change="loadList" class-name="h-tabs-card"></Tabs>

            <!-- 按账户汇总 -->
            <table class="grid" v-if="groupBy === 'account'">
                <thead>
                <tr>
                    <th style="width:120px">编码</th>
                    <th style="min-width:160px">账户名称</th>
                    <th style="width:130px">期初余额</th>
                    <th style="width:130px">收入总额</th>
                    <th style="width:130px">支出总额</th>
                    <th style="width:130px">余额</th>
                    <th style="width:90px">收入笔数</th>
                    <th style="width:90px">支出笔数</th>
                </tr>
                </thead>
                <tbody>
                <template v-for="g in accountGroups">
                    <tr v-for="item in g.rows" :key="g.key + '-' + item.id">
                        <td>{{item.code}}</td>
                        <td>{{item.name}}</td>
                        <td align="right">{{item.beginBalance|numFormat}}</td>
                        <td align="right">{{item.incomeTotal|numFormat}}</td>
                        <td align="right">{{item.expenseTotal|numFormat}}</td>
                        <td align="right">{{item.endBalance|numFormat}}</td>
                        <td align="right">{{item.incomeCount}}</td>
                        <td align="right">{{item.expenseCount}}</td>
                    </tr>
                    <tr class="subtotal" :key="g.key + '-sum'">
                        <td colspan="2" align="center">{{g.title}}</td>
                        <td align="right">{{sum(g.rows, 'beginBalance')|numFormat}}</td>
                        <td align="right">{{sum(g.rows, 'incomeTotal')|numFormat}}</td>
                        <td align="right">{{sum(g.rows, 'expenseTotal')|numFormat}}</td>
                        <td align="right">{{sum(g.rows, 'endBalance')|numFormat}}</td>
                        <td align="right">{{sum(g.rows, 'incomeCount')}}</td>
                        <td align="right">{{sum(g.rows, 'expenseCount')}}</td>
                    </tr>
                </template>
                <tr class="total">
                    <td colspan="2" align="center">总计</td>
                    <td align="right">{{sum(datas, 'beginBalance')|numFormat}}</td>
                    <td align="right">{{sum(datas, 'incomeTotal')|numFormat}}</td>
                    <td align="right">{{sum(datas, 'expenseTotal')|numFormat}}</td>
                    <td align="right">{{sum(datas, 'endBalance')|numFormat}}</td>
                    <td align="right">{{sum(datas, 'incomeCount')}}</td>
                    <td align="right">{{sum(datas, 'expenseCount')}}</td>
                </tr>
                <tr v-if="!datas.length">
                    <td colspan="8" class="text-center padding">暂无数据</td>
                </tr>
                </tbody>
            </table>

            <!-- 按收支类别汇总 -->
            <table class="grid" v-else>
                <thead>
                <tr>
                    <th style="width:120px">编码</th>
                    <th style="min-width:160px">收支类别</th>
                    <th style="width:150px">期初余额</th>
                    <th style="width:150px">收入总额</th>
                    <th style="width:150px">支出总额</th>
                    <th style="width:150px">余额</th>
                    <th style="width:110px">收入笔数</th>
                    <th style="width:110px">支出笔数</th>
                </tr>
                </thead>
                <tbody>
                <template v-for="g in ioTypeGroups">
                    <tr v-for="item in g.rows" :key="g.key + '-' + item.id">
                        <td>{{item.code}}</td>
                        <td>{{item.name}}</td>
                        <td align="right">{{item.beginBalance|numFormat}}</td>
                        <td align="right">{{item.incomeTotal|numFormat}}</td>
                        <td align="right">{{item.expenseTotal|numFormat}}</td>
                        <td align="right">{{item.endBalance|numFormat}}</td>
                        <td align="right">{{item.incomeCount}}</td>
                        <td align="right">{{item.expenseCount}}</td>
                    </tr>
                    <tr class="subtotal" :key="g.key + '-sum'">
                        <td colspan="2" align="center">{{g.title}}</td>
                        <td align="right">{{sum(g.rows, 'beginBalance')|numFormat}}</td>
                        <td align="right">{{sum(g.rows, 'incomeTotal')|numFormat}}</td>
                        <td align="right">{{sum(g.rows, 'expenseTotal')|numFormat}}</td>
                        <td align="right">{{sum(g.rows, 'endBalance')|numFormat}}</td>
                        <td align="right">{{sum(g.rows, 'incomeCount')}}</td>
                        <td align="right">{{sum(g.rows, 'expenseCount')}}</td>
                    </tr>
                </template>
                <tr class="total">
                    <td colspan="2" align="center">总计</td>
                    <td align="right">{{sum(datas, 'beginBalance')|numFormat}}</td>
                    <td align="right">{{sum(datas, 'incomeTotal')|numFormat}}</td>
                    <td align="right">{{sum(datas, 'expenseTotal')|numFormat}}</td>
                    <td align="right">{{sum(datas, 'endBalance')|numFormat}}</td>
                    <td align="right">{{sum(datas, 'incomeCount')}}</td>
                    <td align="right">{{sum(datas, 'expenseCount')}}</td>
                </tr>
                <tr v-if="!datas.length">
                    <td colspan="8" class="text-center padding">暂无数据</td>
                </tr>
                </tbody>
            </table>

            <div class="padding-15 text-gray" v-if="groupBy === 'ioType'">
                提示：内部转账，不计入收支。
            </div>
        </div>
    </app-content>
</template>

<script>
export default {
    name: 'CashierReport',
    data() {
        const now = new Date();
        const ym = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`;
        return {
            datas: [],
            p1: ym,
            p2: ym,
            groupBy: 'account',
            tabDatas: { account: '按账户汇总', ioType: '按收支类别汇总' }
        };
    },
    computed: {
        accountGroups() {
            const cash = this.datas.filter(d => Number(d.type) === 1);
            const bank = this.datas.filter(d => Number(d.type) === 2);
            return [
                { key: 'cash', title: '现金合计', rows: cash },
                { key: 'bank', title: '银行存款总计', rows: bank }
            ];
        },
        ioTypeGroups() {
            return [
                { key: 'in', title: '收入合计', rows: this.datas.filter(d => Number(d.ioType) === 1) },
                { key: 'out', title: '支出合计', rows: this.datas.filter(d => Number(d.ioType) === 2) }
            ];
        }
    },
    methods: {
        fmtPeriod(d) {
            if (!d) return '';
            if (typeof d === 'string') return d;
            return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
        },
        loadList() {
            this.$api.funds.journal.report({
                p1: this.fmtPeriod(this.p1),
                p2: this.fmtPeriod(this.p2),
                groupBy: this.groupBy
            }).then(({ data }) => {
                this.datas = (data || []).map(d => Object.assign({}, d, {
                    endBalance: (Number(d.beginBalance) || 0) + (Number(d.incomeTotal) || 0) - (Number(d.expenseTotal) || 0)
                }));
            });
        },
        sum(rows, field) {
            return (rows || []).reduce((s, d) => s + Number(d[field] || 0), 0);
        },
        exportCsv() {
            let head, rows;
            if (this.groupBy === 'account') {
                head = ['编码', '账户名称', '期初余额', '收入总额', '支出总额', '余额', '收入笔数', '支出笔数'];
                rows = this.datas.map(d => [d.code, d.name, d.beginBalance, d.incomeTotal, d.expenseTotal,
                    d.endBalance, d.incomeCount, d.expenseCount]);
                rows.push(['总计', '', this.sum(this.datas, 'beginBalance'), this.sum(this.datas, 'incomeTotal'),
                    this.sum(this.datas, 'expenseTotal'), this.sum(this.datas, 'endBalance'),
                    this.sum(this.datas, 'incomeCount'), this.sum(this.datas, 'expenseCount')]);
            } else {
                head = ['编码', '收支类别', '期初余额', '收入总额', '支出总额', '余额', '收入笔数', '支出笔数'];
                rows = this.datas.map(d => [d.code, d.name, d.beginBalance, d.incomeTotal, d.expenseTotal,
                    d.endBalance, d.incomeCount, d.expenseCount]);
                rows.push(['总计', '', this.sum(this.datas, 'beginBalance'), this.sum(this.datas, 'incomeTotal'),
                    this.sum(this.datas, 'expenseTotal'), this.sum(this.datas, 'endBalance'),
                    this.sum(this.datas, 'incomeCount'), this.sum(this.datas, 'expenseCount')]);
            }
            const csv = [head].concat(rows).map(r => r.map(c => `"${c == null ? '' : c}"`).join(',')).join('\r\n');
            this.download(`资金报表_${this.groupBy}_${this.fmtPeriod(this.p1)}_${this.fmtPeriod(this.p2)}.csv`, '\ufeff' + csv);
        },
        download(name, content) {
            const blob = new Blob([content], { type: 'text/csv;charset=utf-8' });
            const a = document.createElement('a');
            a.href = URL.createObjectURL(blob);
            a.download = name;
            a.click();
            URL.revokeObjectURL(a.href);
        },
        printPage() { window.print(); }
    },
    mounted() {
        this.loadList();
    }
};
</script>

<style scoped lang="less">
    .filter-bar {
        display: flex;
        align-items: center;
        gap: 8px;
        flex-wrap: wrap;

        .label { margin-left: 6px; }
        .flex-spacer { flex: 1; }
    }

    .grid {
        width: 100%;
        border-collapse: collapse;
        margin-top: 10px;

        th, td {
            padding: 0 8px;
            border: 1px solid #e2e2e2;
            font-size: 12px;
            height: 32px;
            white-space: nowrap;
        }

        th {
            background-color: #f5f5f5;
            text-align: center;
            font-weight: bold;
            height: 35px;
        }

        tbody tr:hover { background-color: #f0f6ff; }

        .subtotal td { background-color: #fffbe6; font-weight: bold; }
        .total td { background-color: #f5f5f5; font-weight: bold; }
    }
</style>
